import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { ProfileFilledIcon } from '@icons';
import { UserIcon } from '@icons';
import { formattedNumber } from '@utils/formattedNumber.ts';
import { ROUTES } from '@utils/routes.ts';

import { useQueryGetMe } from '@hooks/api/user/use-query-me.ts';
import useGetPointsIcon from '@hooks/use-get-points-icon.tsx';
import useIsInIframe from '@hooks/use-is-in-iframe.ts';

import { config } from '@/config.ts';

import { LangSwitcher } from '../lang-switcher';
import * as Styled from './profile.styled.ts';
import { getNavListForBrand } from '../nav/nav-config.ts';

type OwnProps = {
	openAuth: () => void;
};

const isNgu3 = config.BRAND === 'ngu3';
const isRockets = config.BRAND === 'rockets';
const isBlitz = config.BRAND === 'blitz';
const isSk2 = config.BRAND === 'sk2';
const isCom2 = config.BRAND === 'com2';

const isExternalBrand = isRockets || isBlitz || isSk2;

const Profile: React.FC<OwnProps> = ({ openAuth }) => {
	const { data: userData } = useQueryGetMe();
	const { t } = useTranslation();
	const PointsIcon = useGetPointsIcon();
	const navList = getNavListForBrand(config.BRAND, !!userData?.pm_id);
	const isIframe = useIsInIframe();

	return (
		<Styled.Wrapper>
			<Styled.BrandTitle>
				{isExternalBrand ? '' : isNgu3 ? 'X-Pass' : isCom2 ? 'VIP-Pass' : 'PM Pass 2.0'}
			</Styled.BrandTitle>
			{userData?.pm_id ? (
				<>
					<Styled.PointsWrapper $isBlitz={isBlitz || isSk2}>
						<Styled.PointsLabel>
							{PointsIcon} {!isBlitz && t('points')}
						</Styled.PointsLabel>
						<Styled.PointsValue>{formattedNumber(userData.pm_points)}</Styled.PointsValue>
					</Styled.PointsWrapper>
					{!navList.find(arrItem => arrItem.key === 'buy_history') && (
						<>
							<Styled.Divider />
							<Styled.ProfileButton to={ROUTES.PROFILE}>
								<ProfileFilledIcon /> {t('profile')}
							</Styled.ProfileButton>
						</>
					)}
				</>
			) : (
				!isIframe && (
					<>
						<Styled.DesktopAuthButton>
							<Styled.CustomAuthBtn $isCom2={isCom2} color='primary' size='large' minWidth={87} onClick={openAuth}>
								{t('enter')}
							</Styled.CustomAuthBtn>
						</Styled.DesktopAuthButton>
						<Styled.MobileAuthButton $isCom2={isCom2} onClick={openAuth}>
							<UserIcon />
							{t('to_enter')}
						</Styled.MobileAuthButton>
					</>
				)
			)}
			<LangSwitcher />
		</Styled.Wrapper>
	);
};

export default Profile;
